import React, { useCallback } from 'react';
import { Grid } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import clsx from 'clsx';

import { StudioControlStyles } from '../../styles';
import { Button } from '../../../index';
import { CircleIcon } from '../../../icon/solid';
import {
  selectCameraId,
  selectCameraRecording,
} from '../../../../store/modules/studio/selectors';
import { toggleCameraRecording } from '../../../../store/modules/studio/actions';
import StudioToolTip from "../../actions/StudioToolTip";

const RecordAction = () => {
  const classes = StudioControlStyles();
  const dispatch = useDispatch();
  const isRecording = useSelector(selectCameraRecording);
  const cameraId = useSelector(selectCameraId);

  const onClick = useCallback(() => {
    dispatch(toggleCameraRecording());
  }, [dispatch]);

  return (
    <StudioToolTip title={'Start or stop recording'}>
      <Grid item>
        <Button
          onClick={onClick}
          className={clsx(
            classes.button,
            classes.circleButton,
            isRecording ? classes.activeButton : '',
            !cameraId ? classes.disabledRecordButton : '',
          )}
          disabled={!cameraId}
          classes={{
            label: classes.circleButton,
          }}
        >
          <CircleIcon className={clsx(classes.icon, isRecording ? classes.recordIcon : '', !cameraId ? classes.disabledRecordIcon : '')} />
        </Button>
      </Grid>
    </StudioToolTip>
  );
};

export default RecordAction;
